import { LogIn, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="min-h-screen bg-[#f8fafc] text-[#0f172a] flex items-center justify-center px-6"
      data-testid="login-page"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-8" data-testid="app-logo">
          <svg
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-9 h-9 text-[#0284c7]"
            aria-hidden="true"
          >
            <path d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 16c0-3.866 3.134-7 7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="16" cy="16" r="2.5" fill="currentColor"/>
          </svg>
          <div>
            <h1 className="font-heading font-bold text-2xl leading-tight text-[#0f172a]">nikorounds</h1>
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#94a3b8] font-medium">
              Daily rounds · Quality command
            </p>
          </div>
        </div>

        <div className="bg-white border border-[#e2e8f0] rounded-2xl p-8 shadow-[0_2px_20px_rgba(0,0,0,0.04)]">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-[#475569]">
            Sign in
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-1 leading-tight">
            Welcome back
          </h2>
          <p className="text-sm text-[#475569] mt-2">
            Use your Google account to continue. Access is invite-only during the pilot.
          </p>

          <Button
            onClick={handleLogin}
            className="mt-6 w-full h-11 bg-[#0f172a] hover:bg-[#0284c7] text-white font-medium"
            data-testid="google-login-button"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Continue with Google
          </Button>

          <div className="mt-6 space-y-2 text-xs text-[#475569]">
            <div className="flex items-start gap-2">
              <ShieldCheck className="w-3.5 h-3.5 mt-0.5 text-[#0284c7] shrink-0" />
              <span>Sessions expire after 7 days. HIPAA-adjacent — never share your login.</span>
            </div>
            <div className="flex items-start gap-2">
              <Sparkles className="w-3.5 h-3.5 mt-0.5 text-[#d96c4e] shrink-0" />
              <span>
                Not on the allowlist yet? Ask the app owner to add your email.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
